import React, { useState } from 'react';
import styled from 'styled-components';
import { Col, Input, Row, Typography, Empty } from 'antd';
import SubBanner from '../components/SubBanner';
import ContentContainer from '../components/ContentContainer';
import Section from '../components/Section';
import CardNews from '../components/CardNews';
import PaginatedList from '../components/PaginatedList';
import ENDPOINTS from '../constants/endpoints';
import { ROUTES } from '../constants/PathRoutes';

const { Search } = Input;
const { Paragraph } = Typography;

const StyledSection = styled(Section)`
  padding-top: 24px;
  padding-bottom: 24px;
`;

const IntroText = styled(Paragraph)`
  text-align: center;
  font-size: 16px;
  color: #666;
  margin-bottom: 32px;
`;

export default function Transparency() {
    const [search, setSearch] = useState('');

    return (
        <>
            <SubBanner title={'Transparência'} />
            <StyledSection>
                <ContentContainer>
                    <IntroText>
                        Confira nossos documentos, relatórios e informações públicas em nosso compromisso com a transparência.
                    </IntroText>

                    <Row gutter={[0, 24]}>
                        <Col xs={24} md={{ offset: 12, span: 12 }}>
                            <Search
                                placeholder="Pesquisar por documentos"
                                size="large"
                                allowClear
                                onSearch={(value) => setSearch(value)}
                            />
                        </Col>
                        <Col xs={24}>
                            <PaginatedList
                                request={{
                                    url: ENDPOINTS.TRANSPARENCY_LIST_PUBLIC,
                                    params: { search },
                                    dependence: [search]
                                }}
                                showTotal={false}
                                emptyComponent={
                                    <Row justify="center">
                                        <Empty description="Sem documentos no momento" />
                                    </Row>
                                }
                            >
                                {(documents) => (
                                    <Row gutter={[24, 24]} align="start">
                                        {documents.map(({ title, created_at, preview, image, slug }) => (
                                            <Col xs={24} sm={12} lg={8} key={slug}>
                                                <CardNews
                                                    title={title}
                                                    created_at={created_at}
                                                    resume={preview}
                                                    slug={slug}
                                                    image={image}
                                                    baseRoute={ROUTES.TRANSPARENCIA}
                                                />
                                            </Col>
                                        ))}
                                    </Row>
                                )}
                            </PaginatedList>
                        </Col>
                    </Row>
                </ContentContainer>
            </StyledSection>
        </>
    );
}